import { AiOutlineBarChart, AiOutlineCheck } from 'react-icons/ai';
import { generateItemTypeIcon } from '../../../../tools/itemTypeConversion';
import './RelationalItem.css';

import React, { useState } from 'react'
import { HiArrowsRightLeft } from 'react-icons/hi2';
import { TbCompass } from 'react-icons/tb';
import DatumList from '../Datum/DatumList';
import { MdArrowForwardIos, MdOutlineSell } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { fetchModalItem } from '../../../../actions/ModalAction';
import { generateRelationIcon } from '../../../../tools/generateRelationIcon';

const RelationalItem = ( { item, parentItemObj } ) => {

    const {user} = useSelector((state)=>state.authReducer.authData);
    const dispatch = useDispatch();
    const [showContent, setShowContent] = useState(false);
    const sessionId = localStorage.getItem('sessionId');
    const relations = item.relations;
    let align = 0;
    let conflict = 0;

    if(user.userType === 0) {
        align = item.gitemAlignTriggers
        conflict = item.gitemConflictTriggers;
    }
    if (user.userType === 2) {
        align = item.itemOwnAlignTriggers;
        conflict = item.itemOwnConflictTriggers;
    }

    const loadItem = () => {
        var logObject = {
            sessionId,
            location: "from_relationalItem",
            value: item.itemId,
            ...parentItemObj
        };
        dispatch(fetchModalItem(item.itemId, user._id, logObject));
    }
    const displayData = () => {
        setShowContent(prev => !prev);
    };



  return (
    <div className="RelationalItem FlexColumn">
        <div className="ri-item-bar FlexRow">
            <div className="ri-pre-icons ri-spacing FlexColumn">
                <span id={"ri_data_button_" + item.itemId} className={`ri-icon-group ri-spacing FlexRow ${showContent ? 'ri-button-selected' : ''}`} onClick={()=>displayData(item.itemId)}>
                    <AiOutlineBarChart/>
                    <MdArrowForwardIos id={"ri_data_arrow_" + item.itemId} className={`ri-arrow ${showContent ? 'ri-rotated' : ''}`} />
                </span>
            </div>
            <div 
                id={"relational_item_" + item.itemId}
                className="ri-item-container FlexRow ri-normal"
            >
                <div className="arm-link-item-imageContainer">
                    <img src={process.env.REACT_APP_PUBLIC_FOLDER + item.image} />
                </div>
                <div className='arm-link-item-infoContainer FlexColumn'  onClick={loadItem}>
                    <div className="arm-link-item-nameBar FlexRow">
                        <div className="arm-link-item-itemName">{item.itemName}</div>
                        <div className='arm-link-item-itemIcon'>{generateItemTypeIcon(item.itemType)}</div>
                    </div>
                    <div className='ri-stats-bar'>
                        <span className='ri-stat FlexRow'>
                            <span>
                                <HiArrowsRightLeft /><AiOutlineBarChart />
                            </span>
                            {item.relatedData.length}
                        </span>
                        {/* <span className='ri-stat FlexRow'>
                            <span>
                                <HiArrowsRightLeft /><VscTypeHierarchy />
                            </span>
                            ?
                        </span> */}
                        <span className="ri-stat FlexRow">
                            {(item.transferrence >= 0 && conflict > 0) && (
                                <>
                                    <TbCompass className="conflictIcon" />{conflict}
                                    {align > 0 && <span style={{ margin: '0 4px' }}></span>}
                                </>
                            )}
                            {(item.transferrence >= 0 && align > 0) && (
                                <>
                                    <TbCompass className="alignIcon" />{align}
                                </>
                            )}
                        </span>
                        <span className='ri-stat FlexRow arm-link-item-itemIcon'>
                            {relations.map((relation) => generateRelationIcon(relation))}
                        </span>
                    </div>
                </div>
            </div>
            
        </div>
        <div id={"ri_content_" + item.itemId} className={`ri-content ${!showContent ? 'General-hidden' : ''}`}>
        {showContent && item.relatedData.map((datum, id) => (
            <DatumList
                data={datum}
                key={id}
                transferrence={item.transferrence}
                triggerType={item.transferrence >= 0 
                    ? (Array.isArray(datum.triggerTypes) && datum.triggerTypes.length > 0 ? datum.triggerTypes[0] : null) 
                    : null}
            />
        ))}
        </div>
    </div>
  )
}

export default RelationalItem